import React from 'react';
import { MoreHorizontal, ThumbsDown, Meh, ThumbsUp, Star, Rocket, Paperclip, Image } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from '../../ui/dropdown-menu';
import type { Idea } from '../../../types/database';

interface IdeaCardProps {
  idea: Idea;
  onExpand: () => void;
  promote: () => void;
  promptRank: () => void;
  toggleArchive: () => void;
  deleteIdea: () => void;
}

const IdeaCard: React.FC<IdeaCardProps> = ({ idea, onExpand, promote, promptRank, toggleArchive, deleteIdea }) => {
  const ratingIcons = [<ThumbsDown size={14}/>,<ThumbsDown size={14}/>,<Meh size={14}/>,<Meh size={14}/>,<ThumbsUp size={14}/>,<ThumbsUp size={14}/>,<Star size={14}/>,<Star size={14}/>,<Rocket size={14}/>,<Rocket size={14}/>];

  return (
    <Card onClick={onExpand} className="relative group cursor-pointer">
      <CardContent className="p-4 space-y-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-sm line-clamp-2 pr-4">{idea.title}</h3>
          <span className="text-muted-foreground">{ratingIcons[(idea.rank??5)-1]}</span>
        </div>
        {idea.description && (
          <p className="text-xs text-muted-foreground line-clamp-3">{idea.description}</p>
        )}
      </CardContent>

      {/* dropdown */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <MoreHorizontal size={16} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={promote}>Convert to Project</DropdownMenuItem>
          <DropdownMenuItem onSelect={promptRank}>Set Rank</DropdownMenuItem>
          <DropdownMenuItem onSelect={toggleArchive}>{idea.archived ? 'Unarchive' : 'Archive'}</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={deleteIdea} className="text-destructive">Delete</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </Card>
  );
};

export default IdeaCard; 